import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment'
import '../../assets/css/project-creation-mytask.css';
import { getMyTaskAction, getInProgressAction, updateStatusAction } from '../../redux/actions/MyTaskAction';
import { TaskTable, InprogressTable } from '../../components/MyTask/';
import { SecureGateRoute, BreadCrumb } from '../../components';
import { Storage, AppSettings } from '../../configs'
import { setStatusUnlockPOAction } from '../../redux/actions/AppAction.js'
import {
    clearFileAction,
} from '../../redux/actions/UploadAction'
import { msg } from '../../components/Notifications/MsgBox';
import { getUserInformationAction } from '../../redux/actions/UserAction';
import { SearchPoModal,SelectTypeWork } from "../../components"
import {
    clearPODetailAction,
    getPODetailAction,
} from '../../redux/actions/MainAction'

import {
    clearSearchDirectoryInfoAction,
} from '../../redux/actions/MasterAction'
import {
    setKeyValueAction,
    clearModalAction
} from '../../redux/actions/ModalEmployeeAction'

import { setPo_ContarctAction   } from '../../redux/actions/DocControlAction';
import { getYearEndPOListAction } from '../../redux/actions/ContractPOAction';
import { getChangeCommitteeAllAction } from '../../redux/actions/ChangeCommitteeAction'
import ChangeCommitteeService from '../../services/ChangeCommitteeService'
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CustomDialog from '../../components/Notifications/Dialog';
import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction.js"
import UserServices from '../../services/UserServices.js';

class MyTaskScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            countmytask: 0,
            //po_contract_no: ""
            complete_date_notcheck_po_date: [],
            lineTextConfirmCommiteeAmount: [],
            lineTextConfirmCommiteeAmountSubject: '',
            appReadonly: true
        }

        this.handlerAddClick = this.handlerAddClick.bind(this);
        this.handleOnfilter = this.handleOnfilter.bind(this);
        this.handleLoadDataToMyTask = this.handleLoadDataToMyTask.bind(this);
        this.handlerUpdateStatus = this.handlerUpdateStatus.bind(this)

    }

    componentDidMount() {

        const datelocalStorage = Storage.getDatelocalStorage()
        let getdate = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0)).format('YYYYMMDD')
        if (datelocalStorage != getdate) {
            //ถ้าเคย Log in ผ่านไปแล้ว จะไปดึงข้อมูล user มาอัพเดตใน loclstorage วันละครั้ง
            this.props.history.push({
                pathname: AppSettings.loginUrl
            })
            return
        }
        else {

            this.props.startLoading()
            UserServices.info().then(response => {

                this.props.stopLoading()
                let success=response.success
                let user=response.user
                let employee=response.employee
                let role=employee?employee.role: "C"

                if(success)
                {
                    Storage.setUser(user)
                    Storage.setRole(role)
                    Storage.setEmployeePIS(employee)
                    Storage.setDatelocalStorage()

                    if (role === 'C') {
                        this.props.getMyTask(1, user.userName, role, '')
                        this.props.getInProgress(2, user.userName, role, '')
                    }

                    if (role === 'R') {
                        this.props.getMyTask(1, user.userName, role, employee.departmentCode)
                        this.props.getInProgress(2, user.userName, role, employee.departmentCode)
                    }

                }else{

                    user = Storage.getUser()
                    role = Storage.getRole()
                    employee = Storage.getEmployeePIS()

                    if (role === 'C') {
                        this.props.getMyTask(1, user.userName, role, '')
                        this.props.getInProgress(2, user.userName, role, '')
                    }

                    if (role === 'R') {
                        this.props.getMyTask(1, user.userName, role, employee.departmentCode)
                        this.props.getInProgress(2, user.userName, role, employee.departmentCode)
                    }
                }
            }).catch(err => {
                console.log(err)
                this.props.stopLoading()

                    let _user = Storage.getUser()
                    let _role = Storage.getRole()
                    let _employeePIS = Storage.getEmployeePIS()

                    if (_role === 'C') {
                        this.props.getMyTask(1, _user.userName, _role, '')
                        this.props.getInProgress(2, _user.userName, _role, '')
                    }

                    if (_role === 'R') {
                        this.props.getMyTask(1, _user.userName, _role, _employeePIS.departmentCode)
                        this.props.getInProgress(2, _user.userName, _role, _employeePIS.departmentCode)
                    }
            });
        }
        this.ApplicationCheckReadonly()
    }

    handlerAddClick(e) {
        //clear old data in redux
        this.props.clearPODetail();
        this.props.clearFile();
        // this.props.history.push({
        //     pathname: '/main',
        //     search: `?mode=NEW`,
        //     state: { mode: 'NEW' }
        // });   
        window.$('#searchPoModal').modal('show');
    }

    handlerSelectWorkType(type) {
        this.props.clearSearchDirectoryInfo();
        this.props.clearModal();
        window.$('#searchPoModal').modal('hide');
        window.$('#selectTypeWorkModal').modal('hide');
        if (type === "use_bot") {

            this.props.history.push({
                pathname: '/main',
                search: `?mode=NEW`,
                state: { mode: 'NEW' }
            });
        }
        else {
            this.props.history.push({
                pathname: '/mainnotbot',
                search: `?mode=NEW`,
                state: { mode: 'NEW' }
            });
        }

    }

    handleOnCloseConfirmCommittee()
    {
        this.setState({
            openConfirmCommittee: false,
            lineTextConfirmCommiteeAmount: [],
            lineTextConfirmCommiteeAmountSubject: ''
        })
    }

    handleConfirmCommittee(event){
        this.setState({
            openConfirmCommittee: false,
            lineTextConfirmCommiteeAmount: [],
            lineTextConfirmCommiteeAmountSubject: ''
        })

        let prefixPo_no = this.state.tempPrefixPoNo;
        if (prefixPo_no === "41" || prefixPo_no === "31" || prefixPo_no === "32") {
                window.$('#selectTypeWorkModal').modal('show');
        }
        else {
            this.props.setUnlockPO();
            this.props.history.push({
                pathname: '/mainnotbot',
                search: `?mode=NEW`,
                state: { mode: 'NEW' }
            });
        }

    }

    async onSearchPO(po_no, transaction_no, actiontype) {

        let promise = new Promise(async (resolve, reject) => {

            let result = await this.checkYearEndPo(po_no);
            let resultCommittee = await this.checkChangeCommittee(po_no);

            let resultCommitteeCheckAmount = await this.checkCommiteePoAmount(po_no);

            if (result !== null) {
                msg.error(result)
                reject(result);
            }
            else if (resultCommittee != null) {
                msg.error(resultCommittee)
                reject(resultCommittee);
            }
            else {
                let unitCode = null
                let employeePIS = Storage.getEmployeePIS()
                let user = Storage.getUser()

                if (!employeePIS) {
                    // msg.error("ไม่พบข้อมูลผู้ใช้งานนี้ บนระบบส่วนงานบุคคล PIS!")
                    // return
                    unitCode = user.unitCode
                }
                else {
                    unitCode = employeePIS.departmentCode
                }

                this.props.clearPODetail()
                this.props.setPocontract(po_no);
                let prefixPo_no = po_no.substring(0, 2);
                this.setState({
                    tempPrefixPoNo: prefixPo_no
                })

                if(resultCommitteeCheckAmount)
                {
                    this.setState({
                        openConfirmCommittee: resultCommitteeCheckAmount.openConfirmCommittee,
                        lineTextConfirmCommiteeAmount: resultCommitteeCheckAmount.lineTextConfirmCommiteeAmount,
                        lineTextConfirmCommiteeAmountSubject: resultCommitteeCheckAmount.lineTextConfirmCommiteeAmountSubject
                    })
                }else{
                    if (prefixPo_no === "41" || prefixPo_no === "31" || prefixPo_no === "32") {
                        window.$('#selectTypeWorkModal').modal('show');
                    }
                    else {
                       this.props.setUnlockPO();
                       this.props.history.push({
                           pathname: '/mainnotbot',
                           search: `?mode=NEW`,
                           state: { mode: 'NEW' }
                       });
                    }
                }
                

                // await this.props.getPODetail(po_no, transaction_no, unitCode, actiontype, user.userName, this.props.sessionNo, employeePIS.employeeNameTH).then(response => {
                //     const transaction = response.data
                //     const isSuccess = transaction.returnData.isSuccess === true
                //     let returnMessage = transaction.returnData.returnMessage
                //     const errMessage = transaction.returnData.errMessage

                //     console.log('this.props.transaction')
                //     console.log(transaction)

                //     if (!isSuccess && !returnMessage) {
                //         returnMessage = "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้"
                //     }

                //     if (!isSuccess) {
                //         //fail
                //         msg.error(returnMessage)
                //         if (errMessage) console.error("MainScreen.searchPO()", errMessage)
                //         reject(errMessage)
                //     }
                //     else {
                //         //success
                //         let purOrg = transaction.t_PO_DETAIL.puR_CH_ORG
                //         let plants = transaction.t_GR_ITEM.map(f => f.plant)

                //         resolve(transaction)
                //         this.props.setPocontract(po_no);
                //         let prefixPo_no = po_no.substring(0, 2);
                //         if (prefixPo_no === "41" || prefixPo_no === "31" || prefixPo_no === "32") {
                //             window.$('#selectTypeWorkModal').modal('show');
                //         }
                //         else {
                //             this.props.setPocontract(po_no);
                //             this.props.setUnlockPO();
                //             resolve(transaction)
                //             this.props.history.push({
                //                 pathname: '/mainnotbot',
                //                 search: `?mode=NEW`,
                //                 state: { mode: 'NEW' }
                //             });
                //         }
                //     }


                // }).catch(error => {
                //     if (error.message) {

                //         if (error.message.indexOf("timeout") > -1) {
                //             msg.error("เชื่อมต่อ Server เกินกว่าเวลาที่กำหนด กรุณาตรวจสอบการเชื่อมต่อ")
                //         }
                //         else {
                //             msg.error(error.message)
                //         }

                //         reject(error.message)
                //     }
                //     else {
                //         reject("searchPO error")
                //     }

                // })
            }
        })
        return promise

    }

    checkPoEndYear(po_contract_no){

        return this.checkYearEndPo(po_contract_no)
    }

    async checkChangeCommittee(po_contract_no){
        let error_Year = ""
        try {
            //const resp = await 
            
          await this.props.getChangeCommitteeAll(po_contract_no).then((resp)=>{
                
                if (resp && resp.data && resp.data.length > 0 && resp.data.filter(w=>w.approve_status!=="COMPLETE" && w.approve_status!=="REJECT").length) {
                    //error_Year =  "หมายเลข PO/Contract: " + po_contract_no + " ไม่สามารถใช้งานได้ เนื่องจากอยู่ระหว่างการขอแก้ คณะกรรมการ<br/>"
                    error_Year = "PO/Contract: " + po_contract_no + "  อยู่ระหว่างแก้ไขคณะกรรมการตรวจรับ ไม่สามารถ ทำรายการได้ <br/>"
                }
            })

        } catch (error) {
            console.log("error ==> ", error)
            error_Year = error + " " + error_Year + "ไม่สามารถตรวจสอบ หมายเลข PO/Contract: " + po_contract_no + " นี้ได้<br/>"
        }
        if (error_Year !== ""){
            return error_Year
        }
        return null;
    }

   async checkYearEndPo(po_contract_no){
        let error_Year = ""
        try {
            //const resp = await 
            
          await this.props.getYearEndPOList(po_contract_no).then((resp)=>{
                if (resp && resp.data.response.length > 0 && resp.data.response[0].lock_status === "Y") {
                    
                    error_Year =  "หมายเลข PO/Contract: " + po_contract_no + " ถูก Lock ไม่สามารถใช้งานได้<br/>"
                }
            })

        } catch (error) {
            console.log("error ==> ", error)
            error_Year = error + " " + error_Year + "ไม่สามารถตรวจสอบ หมายเลข PO/Contract: " + po_contract_no + " นี้ได้<br/>"
        }
        if (error_Year !== ""){
            return  error_Year
        }
        return null;
    }

    async ApplicationCheckReadonly()
    {
        await UserServices.ApplicationReadonly().then(response=>{
            if(response.data === false)
            {
                this.setState({
                    appReadonly: false
                })
            }
        })
    }

    async checkCommiteePoAmount(po_contract_no){
        let result = null;
        try {
            //const resp = await 
         this.props.startLoading()
          var response = await ChangeCommitteeService.getIsCheckPOCommitteeConfirmAmountByPO(po_contract_no);

          if(response)
            {
            
                if(response.isSuccess === true)
                {
                    if(response.data.isCheckPOCommitteeConfirmAmount === true)
                    {
                        result = {
                            openConfirmCommittee: true,
                            lineTextConfirmCommiteeAmount: response.data.lines,
                            lineTextConfirmCommiteeAmountSubject: response.data.subject
                        }
                    }
                }else{
                    console.log(response.message)
                }

                this.props.stopLoading()
            }

        } catch (error) {
            console.log("error ==> ", error)
            this.props.stopLoading()
        }
        return result;
    }

    async handleOnfilter(count) {

        await this.setState({ countmytask: count })
    }

    handleLoadDataToMyTask() {

        const user = Storage.getUser()
        const role = Storage.getRole()
        const employeePIS = Storage.getEmployeePIS()

        if (!user) return

        if (role === 'C') {
            this.props.getMyTask(1, user.userName, role, '');
            this.props.getInProgress(2, user.userName, role, '');
        }

        if (role === 'R') {
            this.props.getMyTask(1, user.userName, role, employeePIS.departmentCode);
            this.props.getInProgress(2, user.userName, role, employeePIS.departmentCode);
        }
    }

    handlerUpdateStatus(object) {
        const user = Storage.getUser()
        const role = Storage.getRole()
        const employeePIS = Storage.getEmployeePIS()

        if (object.length > 0) {
            this.props.updateStatus(object).then(res => {

                if (res.data.isSuccess) {
                    msg.success(res.data.returnMessage)
                    if (role === 'C') {
                        this.props.getMyTask(1, user.userName, role, '');
                        this.props.getInProgress(2, user.userName, role, '');
                    }

                    if (role === 'R') {
                        this.props.getMyTask(1, user.userName, role, employeePIS.departmentCode);
                        this.props.getInProgress(2, user.userName, role, employeePIS.departmentCode);
                    }
                }
                else {
                    msg.error(res.data.returnMessage)
                }
            })
        }
    }

    render() {
        console.log("render");
        return (
            <div className="project-creation project-creation-mytask">
                <SecureGateRoute />
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            { name: 'RRS Home', url: AppSettings.defaultUrl }
                        ]}></BreadCrumb>

                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">RRS Home</h1>
                            </div>
                        </div>
                        <div id="resultTabContainer">
                            <div className="row sp-project-counter-wrap">
                                <div className="col-md-4 sp-project-counter-panel">
                                    <a href="#" className="sp-project-counter-link" id="myTaskTabNav" data-toggle="collapse" data-target="#myTaskTab" aria-expanded="true" aria-controls="myTaskTab">
                                        <div className="sp-project-counter-qty">{this.props.myTask.length}</div>
                                        <div className="sp-project-counter-label-box">
                                            <i className="icon icon-tasks-assign-to-me" />
                                            <div className="sp-project-counter-label table-cell">My Task</div>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-md-4 sp-project-counter-panel">
                                    <a href="#" className="sp-project-counter-link collapsed" id="inProgressTabNav" data-toggle="collapse" data-target="#inProgressTab" aria-expanded="false" aria-controls="inProgressTab">
                                        <div className="sp-project-counter-qty">{this.props.inProgress.length}</div>
                                        <div className="sp-project-counter-label-box">
                                            <i className="icon icon-tasks-create-by-me" />
                                            <div className="sp-project-counter-label table-cell">In Progress</div>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-md-4 sp-project-counter-panel sp-project-counter-panel-total">
                                    <a className="sp-project-counter-link">
                                        <div className="sp-project-counter-qty">{this.props.myTask.length + this.props.inProgress.length}</div>
                                        <div className="sp-project-counter-label-box">
                                            <i className="icon icon-tasks-total" />
                                            <div className="sp-project-counter-label table-cell">Total</div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            <div className="sp-page-result-container collapsing show" id="myTaskTab" style={{ padding: 20 }} aria-labelledby="myTaskTabNav" data-parent="#resultTabContainer">
                                <div className="sp-table-container">
                                    <div className="row sp-pagination-control-top">
                                        { !this.state.appReadonly && <div className="col-auto create-button">
                                            <a className="sp-bt-addmore" onClick={()=>this.handlerAddClick()} >
                                                <i className="icon btn-plus" />
                                                <span>เพิ่ม</span>
                                            </a>
                                        </div>}
                                    </div>
                                    <div className="row no-gutters sp-table-content">
                                        <TaskTable
                                            tasks={this.props.myTask}
                                            {...this.props}
                                            //onfilter={(count) => this.handleOnfilter(count)}
                                            handlerUpdateStatus={(object) => this.handlerUpdateStatus(object)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="sp-page-result-container collapse" id="inProgressTab" aria-labelledby="inProgressTabNav" data-parent="#resultTabContainer">
                                <InprogressTable 
                                tasks={this.props.inProgress} 
                                {...this.props} />
                                {/* <div className="sp-table-container">
                                    <div className="row no-gutters sp-table-content">

                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            
                <SearchPoModal                                 
                onSearchPO={(po) => { this.onSearchPO(po,null,null) }}
                status_data={this.state.status_data}/>
                <SelectTypeWork
                handlerSelectWorkType={(po) => { this.handlerSelectWorkType(po,null,null) }}
                status_data={this.state.status_data}/>

                <CustomDialog open={this.state.openConfirmCommittee} title={this.state.lineTextConfirmCommiteeAmountSubject} maxWidth="lg"
                onClose={()=>{
                    this.handleOnCloseConfirmCommittee(false)
                }}
                PaperProps={{style: {maxWidth: 1040}}}
                propsTitle={{align: 'center', variant: 'h5', typographyProps: {style:{ marginTop: 12, marginBottom: 12}}}}
                >
                    
                    <Grid container  style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center">
                        <Grid item xs={12} style={{textAlign: 'center'}}>

                            {
                                this.state.lineTextConfirmCommiteeAmount.map((p, i)=> (<label className='font-radio' key={'txt-ConfirmCommittee-line'+i}>{p.display}</label>))
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <p>&nbsp;</p>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={2} justifyContent="center">
                                <Grid item xs={1}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={(event) => {this.handleConfirmCommittee(event)}}>
                                        <i className="icon btn-order-check-green" />
                                        <span className="sp-btn-icon-label3-success">ยืนยัน</span>
                                    </a>
                                </Grid>
                                <Grid item xs={1}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={()=>this.handleOnCloseConfirmCommittee(false)}>
                                        <i className="icon btn-cancel-size-check" />
                                        <span className="sp-btn-icon-label3-cancel">ย้อนกลับ</span>
                                    </a>
                                </Grid>
                            </Grid>
                            
                        </Grid>
                    </Grid>
                </CustomDialog>


            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MyTaskRedux ,DocControlRedux} = state
    return {
        myTask: MyTaskRedux.myTask,
        inProgress: MyTaskRedux.inProgress,
        po_contract_no:DocControlRedux.po_contract_no,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMyTask: (tabId, userId, userRole, userDepartment) => dispatch(getMyTaskAction(tabId, userId, userRole, userDepartment)),
        getInProgress: (tabId, userId, userRole, userDepartment) => dispatch(getInProgressAction(tabId, userId, userRole, userDepartment)),
        clearPODetail: () => dispatch(clearPODetailAction()),
        clearFile: () => dispatch(clearFileAction()),
        updateStatus: (updateStatusArr) => dispatch(updateStatusAction(updateStatusArr)),
        getUserInformation: (user) => dispatch(getUserInformationAction(user)),
        getPODetail: (po_no, tranNo, unitCode, actiontype ,userId ,sessionNo ,userName ) => dispatch(getPODetailAction(po_no, tranNo, unitCode, actiontype, userId,sessionNo , userName)),
        clearSearchDirectoryInfo: () => dispatch(clearSearchDirectoryInfoAction()),
        clearModal: () => dispatch(clearModalAction()),
        setPocontract: (po_contract_no)  => dispatch(setPo_ContarctAction(po_contract_no)),
        getYearEndPOList : (po_contract_no) => dispatch(getYearEndPOListAction(po_contract_no)),
        getChangeCommitteeAll : (po_contract_no) => dispatch(getChangeCommitteeAllAction(po_contract_no)),
        setUnlockPO:() => dispatch(setStatusUnlockPOAction()),
        startLoading: () => dispatch(startLoadingAction()),
        stopLoading: () => dispatch(stopLoadingAction()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyTaskScreen);